<template>
  <div>
    <section-title
      class="mt-4"
      content="Información del Contrato"
      :has-line="true"
    />
    <div class="pb-4 pt-1 px-5 rounded">
      <div class="row mb-5">
        <div class="col-md-4 mt-3">
          <span class="mt-1 color-gray-6 d-block font-14">
            Nombre del Proveedor:
          </span>
          <span class="font-16 color-black font-weight-bold">
            {{ model.providerName | empty }}
          </span>
        </div>
        <div class="col-md-2 mt-3">
          <validation-provider
            v-if="!isReadOnly || (editingCost && this.isNotCancelledContract)"
            ref="cost"
            v-slot="{ failedRules }"
            name="cost"
            rules="required|differentFromZero"
          >
            <span class="color-gray-6 d-block font-14">
              Costo:
            </span>
            <div class="input-group">
              <div class="input-group-prepend">
                <span
                  class="input-group-text text-white px-3"
                  :class="costColor"
                >
                  <i class="fas fa-dollar-sign" />
                </span>
                <span class="input-group-text">
                  {{ maxServiceCost }}
                </span>
              </div>
              <input
                ref="costInput"
                v-model="model.cost"
                class="form-control text-right"
                type="text"
                @input="changeCost($event.target)"
              />
            </div>
            <error
              v-if="failedRules.required || failedRules.differentFromZero"
              message="El costo es requerido."
              variant="no-border"
            />
            <error
              v-if="withoutMaxServiceCost"
              message="No se encontró configuración de costos y servicio en sistema."
              variant="no-border"
            />
            <div
              v-if="
                (canEditCost && editingCost) ||
                  (editingCost && canEditCostInAllStatus)
              "
              class="mt-3 text-right"
            >
              <action-button
                class="btn-action-size mr-2"
                i="fas fa-times-circle"
                variant="outline-danger btn-cancel danger"
                @click="() => disableEditCost()"
              />
              <action-button
                class="btn-action-size"
                i="fas fa-save"
                variant="outline-success btn-success success"
                @click="() => saveCost()"
              />
            </div>
          </validation-provider>
          <div v-else>
            <span class="color-gray-6 d-block font-14">
              Costo:
            </span>
            <span class="d-block font-16 color-secondary-25 mb-3">
              {{ model.cost | price }}
              <action-button
                v-if="canEditCost || canEditCostInAllStatus"
                class="btn-action-size ml-2"
                i="fas fa-edit"
                variant="outline-success btn-success success"
                @click="() => enableEditCost()"
              />
            </span>
          </div>
        </div>
        <div v-if="!isESignatureInitcAcademicYear" class="col-md-2 mt-3">
          <validation-provider
            v-if="!isReadOnly || editingApplicant"
            ref="contrato"
            v-slot="{ errors }"
            name="contrato"
            :rules="isESignatureInitcAcademicYear ? '' : 'required'"
          >
            <span class="color-gray-6 d-block font-14">
              Nombre del Contratante:
            </span>
            <custom-input
              ref="applicantNameInput"
              v-model="model.applicantName"
              :custom-error-msg="'El nombre del contratante es requerido.'"
              :error="errors[0]"
              @input="onContractNameChange"
            />
            <div v-if="isReadOnly" class="mt-3 text-right">
              <action-button
                class="btn-action-size mr-2"
                i="fas fa-times-circle"
                variant="outline-danger btn-cancel danger"
                @click="() => toogleApplicantEditing()"
              />
              <action-button
                class="btn-action-size"
                i="fas fa-save"
                variant="outline-success btn-success success"
                @click="() => saveContractor()"
              />
            </div>
          </validation-provider>
          <div v-else>
            <span class="color-gray-6 d-block font-14">
              Nombre del Contratante:
            </span>
            <span class="d-block font-16 color-black mb-3">
              {{ model.applicantName | empty }}
              <action-button
                v-if="canEditContractor"
                class="btn-action-size ml-2"
                i="fas fa-edit"
                variant="outline-success btn-success success"
                @click="() => toogleApplicantEditing()"
              />
            </span>
          </div>
        </div>
        <div v-if="isESignatureInitcAcademicYear" class="col-md-2 mt-3" />
        <div class="col-md-4 mt-3">
          <validation-provider
            v-if="!isReadOnly"
            v-slot="{ errors }"
            rules="required"
          >
            <span class="color-gray-6 d-block font-14">
              Municipio de Residencia:
            </span>
            <custom-drop-down
              v-model="model.municipalityOfresidence"
              custom-error-msg="El municpio de residencia es requerido."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="municipalitiesOptions"
              placeholder="Seleccione"
              @input="chageResidentMunicipality"
            />
          </validation-provider>
          <div v-else>
            <span class="color-gray-6 d-block font-14">
              Municipio de Residencia:
            </span>
            <span class="d-block font-16 color-black mb-3">
              {{ municipalityOfresidenceName || '-' }}
            </span>
          </div>
        </div>
      </div>
      <div
        v-if="hasTheCostBeenExceeded && canEditCostInAllStatus"
        class="row mb-5 bg-secondary-3 p-3"
      >
        <div class="col-12 rounded bg-white">
          <validation-observer ref="acceptRef" tag="form">
            <div class="row mt-3">
              <div class="col col-sm col-12 pt-2">
                <em class="fas fa-info-circle text-orange mr-1" />
                <span class="color-gray-7 font-16 font-weight-bold">
                  Justificación para Sobrepasar el Tope de la Tarifa
                </span>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12">
                <span class="color-gray-6 d-block font-14 mb-2">
                  Comentario:
                </span>
                <span class="font-16 color-black">
                  <validation-provider v-slot="{ errors }" :rules="'required'">
                    <custom-text-area
                      v-model="model.exceededCostComment"
                      :count-classes="['float-right']"
                      custom-error-msg="El comentario es requerido."
                      :error="errors[0]"
                      :maxlength="3000"
                      show-char-count
                    />
                  </validation-provider>
                </span>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-12">
                <action-button
                  class="float-right ml-2"
                  i="fas fa-save fa-lg"
                  text="Guardar"
                  variant="success mt-3"
                  @click="saveExceededCost"
                />
                <action-button
                  class="float-right"
                  i="fas fa-times-circle"
                  text="Cancelar"
                  variant="outline-danger mb-4 mt-3"
                  @click="disableEditCost"
                />
              </div>
            </div>
          </validation-observer>
        </div>
      </div>
    </div>
    <div class="pb-4 pt-1 px-5 rounded">
      <div
        class="row mb-5"
        :class="{ 'd-flex justify-content-between': !showCostTransportation }"
      >
        <div v-if="canEditeSchedule" class="col-md-4 mt-2">
          <div v-if="isReadOnly">
            <span class="mt-1 color-gray-6 d-block font-14">
              Horario:
            </span>
            <span class="font-16 color-black font-weight-bold">
              {{ model.scheduleAssistantIn }} -
              {{ model.scheduleAssistantOut }}
            </span>
          </div>
          <div v-else>
            <div v-if="isAssistanceServiceType" class="row">
              <div class="col-md-6">
                <span class="mt-1 color-gray-6 d-block font-14">
                  Horario de entrada:
                </span>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text text-white bg-white px-3">
                      <i class="far fa-clock color-orange" />
                    </span>
                  </div>
                  <input
                    id="scheduleAssistantIn"
                    v-model="model.scheduleAssistantIn"
                    v-mask="'##:## AA'"
                    class="form-control"
                    placeholder="HH:mm"
                    type="text"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <span class="mt-1 color-gray-6 d-block font-14">
                  Horario de salida:
                </span>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text text-white bg-white px-3">
                      <i class="far fa-clock color-orange" />
                    </span>
                  </div>
                  <input
                    id="scheduleAssistantOut"
                    v-model="model.scheduleAssistantOut"
                    v-mask="'##:## AA'"
                    class="form-control"
                    placeholder="HH:mm"
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div v-if="isSchoolOrHome">
            <p class="label-gray p-label">
              ¿Tiene costo de transportación?
            </p>

            <validation-provider v-slot="{ errors }" rules="required">
              <custom-radio-button
                id="transportationCost"
                ref="transportationCostRadio"
                v-model="model.hasTransportationCost"
                custom-error-msg="Favor marque si o no."
                :error="errors[0]"
                :is-disabled="isReadOnly || isAssistanceWithoutInterpreter"
                is-inline
                label=""
                name="transportationCost"
                :options="options"
                @input="changeHasTransportationCost($event)"
              />
            </validation-provider>
          </div>
        </div>
        <div
          v-if="
            !isAssistanceServiceType ||
              (isAssistanceServiceType && !isReadOnly) ||
              (isAssistanceServiceType &&
                isReadOnly &&
                isSchoolOrHome &&
                showCostTransportation)
          "
          :class="[isAssistanceServiceType ? 'col-md-2' : 'col-md-4']"
        >
          <div v-if="isSchoolOrHome && showCostTransportation">
            <validation-provider
              v-if="!isReadOnly || showEditableCost"
              ref="contrato"
              v-slot="{ errors }"
              name="contrato"
              rules="required"
            >
              <span class="color-gray-6 d-block font-14">
                Costo de Transportación:
              </span>
              <custom-input
                ref="transportationCostInput"
                v-model="model.transportationCost"
                :custom-error-msg="'El costo de Transportación es requerido.'"
                :error="errors[0]"
                :mask-type="'Money'"
                @input="changeTransportationCost"
              />
              <div v-if="showEditableCost" class="mt-3 text-right">
                <action-button
                  class="btn-action-size"
                  i="fas fa-times-circle"
                  variant="outline-danger btn-cancel danger"
                  @click="() => onShowEditTransportationCost()"
                />
                <action-button
                  class="btn-action-size ml-2"
                  i="fas fa-save"
                  variant="outline-success btn-success success"
                  @click="() => saveTransportationCost()"
                />
              </div>
            </validation-provider>
            <div v-else>
              <span class="color-gray-6 d-block font-14">
                Costo de Transportación:
              </span>
              <span class="font-16 color-green font-weight-bold col-4">
                {{ model.transportationCost | price }}
              </span>
              <action-button
                v-if="!showEditableCost && canEditTransportationCost"
                class="btn-action-size ml-2"
                i="fas fa-edit"
                variant="outline-success btn-success success"
                @click="() => onShowEditTransportationCost()"
              />
            </div>
          </div>
        </div>
        <div v-if="isAssistanceServiceType" :class="workdayClass">
          <validation-provider
            v-if="!isReadOnly"
            ref="workday"
            v-slot="{ errors, failedRules }"
            name="workday"
            :rules="{ required: true, workdayTime: true }"
          >
            <div class="float-right">
              <span class="color-gray-6 d-block font-14">
                Jornada Diaria:
              </span>
              <div class="d-flex">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text text-white bg-white px-3">
                      <i class="far fa-clock color-orange" />
                    </span>
                  </div>
                  <input
                    id="workdayTime"
                    v-model="model.workday"
                    v-mask="'##:##'"
                    class="form-control"
                    :class="errors[0] ? 'was-Invalidated' : ''"
                    maxlength="5"
                    placeholder="HH:mm"
                    type="text"
                    @input="changeHours($event.target)"
                  />
                </div>
              </div>
            </div>
            <div>
              <error
                v-if="failedRules.required"
                message="La jornada diaria es requerida."
                variant="no-border"
              />
              <error
                v-if="failedRules.workdayTime"
                :message="errors[0]"
                variant="no-border"
              />
            </div>
          </validation-provider>
          <div v-else>
            <span class="color-gray-6 d-block font-14">
              Jornada Diaria:
            </span>
            <span class="d-block font-16 color-black mb-3">
              {{ model.workday | empty }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from 'ke-the-mask';
import SectionTitle from 'SectionTitle';
import CustomInput from 'CustomInput';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomRadioButton from 'custom-radio';
import CustomDropDown from 'custom-drop-down';
import Error from 'custom-error';
import {
  getContractInformation as _getContractInformation,
  saveCost as _saveCost,
  saveContractor as _saveContractor,
  saveTransportationCost as _saveTransportationCost,
  saveExceedCost as _saveExceedCost,
} from '@/services/uspqrp/contract.api';
import { getMunicipalities as _getMunicipalities } from '@/services/common/location.api';
import codeLocationTypes from '@/utils/constants/codeLocationTypes.js';
import ActionButton from 'ActionButton';
import rpContractStatus from '@/utils/constants/rpContractStatus';
import disciplineTypes from '@/utils/constants/disciplineTypes';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import { eSignatureInitAcademicYear } from '@/utils/constants/eSignatureInitAcademicYear';
import CustomTextArea from 'CustomTextArea';
import objectToFormData from 'object-to-formdata';

export default {
  name: 'ContractInformation',
  mixins: [alertMixin],
  directives: {
    mask,
  },
  components: {
    SectionTitle,
    CustomInput,
    CustomRadioButton,
    Error,
    ValidationProvider,
    ValidationObserver,
    CustomDropDown,
    ActionButton,
    CustomTextArea,
  },
  props: {
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    info: {
      type: Object,
      default: () => {},
    },
    companyId: {
      type: Number,
      default: null,
    },
    requestServiceId: {
      type: Number,
      default: null,
    },
    locationType: {
      type: Number,
      default: null,
    },
    intervention: {
      type: Object,
      default: () => {},
    },
    location: {
      type: Object,
      default: () => {},
    },
    contractInformationModel: {
      type: Object,
      default: () => {},
    },
    locationMatch: {
      type: Boolean,
      default: null,
    },
    isTherapyServiceType: {
      type: Boolean,
      default: () => false,
    },
    isAssistanceServiceType: {
      type: Boolean,
      default: () => false,
    },
    contractId: {
      type: Number,
      default: null,
    },
    subDisciplineTypeId: {
      type: Number,
      default: () => {},
    },
    contractStatusId: {
      type: Number,
      default: null,
    },
    disciplineTypeId: {
      type: Number,
      default: () => 0,
    },
    contractAcademicYearId: {
      type: Number,
      default: () => 0,
    },
    isElectronicsSignature: {
      type: Boolean,
      default: () => false,
    },
    contractInfoBody: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showEditableCost: false,
      options: [
        {
          label: 'SI',
          value: true,
        },
        {
          label: 'NO',
          value: false,
        },
      ],
      costColor: 'bg-green',
      maxServiceCost: '0.00',
      originalCost: 0,
      model: {
        providerName: null,
        cost: null,
        transportationCost: null,
        applicantName: null,
        exceededCostComment: null,
        workday: null,
        hasTransportationCost: null,
        isBilled: false,
        municipalityOfresidence: null,
      },
      previousCost: null,
      types: [codeLocationTypes.School, codeLocationTypes.Home],
      municipalities: [],
      municipalitySelected: null,
      editingCost: false,
      editingApplicant: false,
      currentInfo: this.info,
      hasTheCostBeenExceeded: false,
    };
  },
  async mounted() {
    await this.getMunicipalities();
    await this.getContractInformation();
    if (this.isAssistanceWithoutInterpreter) {
      this.model.hasTransportationCost = false;
    }
  },
  computed: {
    municipalityOfresidenceName() {
      return this.model.municipalityOfresidence?.name;
    },
    showCostTransportation() {
      return this.model.hasTransportationCost;
    },
    withoutMaxServiceCost() {
      return parseInt(this.maxServiceCost) === 0;
    },
    isSchoolOrHome() {
      if (this.locationType) return this.types.includes(this.locationType);
      return false;
    },
    municipalitiesOptions() {
      return this.municipalities || [];
    },
    canEditTransportationCost() {
      return this.userHasPermissions('rempro.edittransportationcost');
    },
    canEditCost() {
      if (!this.isElectronicsSignature) {
        return (
          this.userHasPermissions('rempro.providers.contract.editcost') &&
          this.contractStatusId != rpContractStatus.New
        );
      }
      var allowedStatus = [
        rpContractStatus.New,
        rpContractStatus.DeniedContractInformation,
        rpContractStatus.ApprovedContractInformation,
      ];
      return (
        this.userHasPermissions('rempro.providers.contract.editcost') &&
        allowedStatus.includes(this.contractStatusId)
      );
    },
    canEditeSchedule() {
      return this.userHasPermissions('rempro.editschedule');
    },
    canEditCostInAllStatus() {
      if (
        this.contractStatusId != rpContractStatus.New &&
        !this.isElectronicsSignature
      ) {
        return this.userHasPermissions('rempro.servicecost.edit');
      }
      var allowedStatus = [
        rpContractStatus.New,
        rpContractStatus.DeniedContractInformation,
        rpContractStatus.ApprovedContractInformation,
      ];
      return (
        this.userHasPermissions('rempro.servicecost.edit') &&
        allowedStatus.includes(this.contractStatusId)
      );
    },
    canEditContractor() {
      var allowedStatus = [
        rpContractStatus.Approved,
        rpContractStatus.Submitted,
        rpContractStatus.Signed,
        rpContractStatus.ApprovedContractInformation,
      ];
      var hasStatus = allowedStatus.includes(this.contractStatusId);
      var isBilled = this.model.isBilled;
      return hasStatus && !isBilled;
    },
    workdayClass() {
      return this.isReadOnly &&
        !(this.isSchoolOrHome && this.showCostTransportation)
        ? 'col-md-4'
        : 'col-md-2';
    },
    isInterpreterDiscipline() {
      return disciplineTypes.Interprete === this.disciplineTypeId;
    },
    isESignatureInitcAcademicYear() {
      return this.contractAcademicYearId >= eSignatureInitAcademicYear;
    },
    isAssistanceWithoutInterpreter() {
      return this.isAssistanceServiceType && !this.isInterpreterDiscipline;
    },
    isNotCancelledContract() {
      return this.contractStatusId != rpContractStatus.ContractCanceled;
    },
  },
  methods: {
    toogleApplicantEditing() {
      this.editingApplicant = !this.editingApplicant;
    },
    async getContractInformation() {
      let payload = {
        locationTypeId: this.locationType,
        therapyDurationId: this.intervention?.duration?.id,
        serviceModalityTypeId: this.intervention?.modality?.id,
        subDisciplineTypeId: this.subDisciplineTypeId,
      };

      if (!this.isTherapyServiceType) {
        payload = {};
      }
      const { data } = await _getContractInformation(
        this.companyId,
        this.requestServiceId,
        this.contractId,
        payload
      );

      this.model.isBilled = data.isBilled;
      this.model.hasVisited = data.hasVisited;
      this.model.providerName = data.companyFullName;
      this.maxServiceCost = data.maxServiceCost;
      this.model.applicantName = data.applicantName;
      this.model.maxServiceCost = data.maxServiceCost;
      this.model.cost = data.cost ? data.cost : null;
      this.model.originalCost = data.cost;
      this.municipalitySelected = data.municipalityId;
      this.model.workday = data.workday;
      this.model.municipalityOfresidence = data.residenceMunicipalityId;

      if (data.cost > 0) {
        if (this.$refs['costInput']) {
          this.model.cost = data.cost;
          this.changeCost({ value: data.cost });
        }
      }

      this.model.municipalityOfresidence = this.municipalitiesOptions.find(
        (m) => m.id === data.residenceMunicipalityId
      );

      if (this.model.applicantName) {
        if (this.$refs['applicantNameInput']) {
          this.$refs['applicantNameInput'].value = this.model?.applicantName;
        }
      }
      if (this.contractInfoBody.contractTransportationCost > 0) {
        this.model.hasTransportationCost = true;
        this.model.transportationCost = this.contractInfoBody.contractTransportationCost;
      } else {
        if (this.isAssistanceWithoutInterpreter) {
          this.model.hasTransportationCost = false;
        }
        this.model.transportationCost = 0;
      }

      this.model.exceededCostComment =
        this.contractInfoBody?.contractCostChangeLog?.exceededCostComment ?? '';

      this.$emit('input', this.model);
    },
    changeCost(e) {
      const value = e.value;
      const cost = parseInt(value) || 0;
      if (cost <= parseInt(this.maxServiceCost)) {
        this.costColor = 'bg-green';
        this.hasTheCostBeenExceeded = false;
      } else {
        this.costColor = 'bg-red';

        var allowedStatus = [
          rpContractStatus.New,
          rpContractStatus.DeniedContractInformation,
          rpContractStatus.ApprovedContractInformation,
        ];
        if (
          (this.userHasPermissions('rempro.providers.contract.editcost') ||
            this.userHasPermissions('rempro.servicecost.edit')) &&
          allowedStatus.includes(this.contractStatusId)
        ) {
          this.hasTheCostBeenExceeded = true;
        } else {
          this.hasTheCostBeenExceeded = false;
        }
      }
      e.value = value?.toString().replace(/[^0-9.-]/g, '');
      if (e.value) {
        this.$refs['cost'].reset();
      } else {
        this.model.cost = null;
        this.$refs['cost'].validate();
      }
      this.$emit('input', this.model);
    },
    changeTransportationCost() {
      this.contractInformationModel.transportationCost = this.model.transportationCost;
      this.$emit('input', this.contractInformationModel);
      this.$emit('input', this.model);
    },
    chageResidentMunicipality() {
      this.contractInformationModel.municipalityOfresidence = this.model.municipalityOfresidence;
      this.$emit('input', this.model);
    },
    changeHours() {
      this.contractInformationModel.workday = this.model.workday;
      this.$emit('input', this.model);
    },
    enableEditCost() {
      this.editingCost = true;
    },
    disableEditCost() {
      this.model.cost = this.model.originalCost;
      this.editingCost = false;
      this.model.exceededCostComment = '';
      this.hasTheCostBeenExceeded = false;
    },
    async saveCost() {
      if (
        this.model.cost > parseFloat(this.maxServiceCost) &&
        !this.canEditCostInAllStatus
      ) {
        this.ShowToast(
          'Alerta',
          'No es posible guardar el costo, ya que el costo del servicio sobrepasa el costo máximo de la configuración.',
          'error'
        );
        return;
      }

      if (this.model.cost > parseFloat(this.maxServiceCost)) {
        var isValid = await this.$refs.acceptRef.validate();
        if (isValid) {
          var payLoad = objectToFormData({
            contractid: this.contractId,
            cost: this.model.cost,
            exceededCostComment: this.model.exceededCostComment,
          });
          await _saveExceedCost(payLoad)
            .then(() => {
              this.ShowToast(
                'Proceso Exitoso',
                'Costo modificado correctamente.',
                'success'
              );
              this.editingCost = false;
              this.hasTheCostBeenExceeded = false;
              this.model.exceededCostComment = '';
            })
            .catch((err) => {
              this.ShowToast('', err.response?.data?.message, 'error');
            });
        }
        return;
      }

      await _saveCost(this.contractId, Number(this.model.cost))
        .then(() => {
          this.ShowToast(
            'Proceso Exitoso',
            'Costo modificado correctamente.',
            'success'
          );
          this.editingCost = false;
        })
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
    async saveContractor() {
      await _saveContractor(this.contractId, this.model.applicantName)
        .then(() => {
          this.ShowToast(
            'Proceso Exitoso',
            'Nombre del Contratante modificado correctamente.',
            'success'
          );
          this.editingApplicant = false;
        })
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
    async saveTransportationCost() {
      await _saveTransportationCost(
        this.contractId,
        this.model.transportationCost
      )
        .then(() => {
          this.ShowToast(
            'Proceso Exitoso',
            'Se ha guardado el costo de transportación correctamente.',
            'success'
          );
          this.showEditableCost = false;
        })
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
    onShowEditTransportationCost() {
      this.showEditableCost = !this.showEditableCost;
    },
    changeHasTransportationCost(value) {
      this.model.hasTransportationCost = value;
      if (
        value &&
        (this.model.transportationCost === null ||
          this.model.transportationCost === 0)
      ) {
        this.model.transportationCost = this.locationMatch ? 10 : 15;
      } else {
        this.model.transportationCost = 0;
      }
      this.$emit('input', this.model);
    },
    async getMunicipalities() {
      const { data } = await _getMunicipalities();
      this.municipalities = data;
    },
    saveSchedule() {
      // Define variables x and y with the values "6:00 AM" and "8:00 PM" respectively
      var x = this.model.scheduleAssistantIn;
      var y = this.model.scheduleAssistantOut;
      if (x != null && y != null) {
        if (!x.match(/(AM|PM)/) || !y.match(/(AM|PM)/)) {
          this.ShowToast(
            'Alerta',
            'El formato del horario ingresado no es valido',
            'error'
          );
          return false;
        }

        // Extract the hour and period (AM/PM) from variables x and y
        var xHour = parseInt(x.split(':')[0]);
        var xPeriod = x.split(' ')[1];
        var yHour = parseInt(y.split(':')[0]);
        var yPeriod = y.split(' ')[1];

        // Compare the hours in 12-hour format and ensure x is not greater than y
        if ((xHour < yHour && xPeriod === yPeriod) || yPeriod === 'PM') {
          return true;
        }
        this.ShowToast(
          'Alerta',
          'La hora de entrada no puede ser mayor a la hora de salida',
          'error'
        );
        return false;
      }
      return true;
    },
    onContractNameChange() {
      this.$emit('input', this.model);
    },
    async saveExceededCost() {
      var isValid = await this.$refs.acceptRef.validate();
      if (isValid) {
        this.saveCost();
      }
    },
    setCost(value) {
      if (value > 0) {
        this.model.cost = value;
        this.model.originalCost = value;
      }
      this.maxServiceCost = Number(value).toFixed(2);
      this.model.maxServiceCost = Number(value).toFixed(2);

      if (this.model.cost > this.model.maxServiceCost) {
        this.costColor = 'bg-red';
        this.hasTheCostBeenExceeded = true;
      } else {
        this.costColor = 'bg-green';
        this.hasTheCostBeenExceeded = false;
      }

      this.$emit('input', this.model);
    },
  },
  watch: {
    'intervention.modality': function() {
      if (!this.isReadOnly && !this.contractId) {
        this.getContractInformation();
      }
    },
    'intervention.duration': function() {
      if (!this.isReadOnly && !this.contractId) {
        this.getContractInformation();
      }
    },
    subDisciplineTypeId: function() {
      if (!this.isReadOnly) {
        this.getContractInformation();
      }
    },
    locationMatch: function(value) {
      if (this.model.hasTransportationCost) {
        value
          ? (this.model.transportationCost = 10)
          : (this.model.transportationCost = 15);
      }
    },
    disciplineTypeId: {
      immediate: true,
      handler(value) {
        if (value && value > 0 && this.isAssistanceWithoutInterpreter) {
          this.model.hasTransportationCost = false;
        }
      },
    },
    contractInfoBody: {
      handler(value) {
        if (value && value.contractTransportationCost !== null) {
          if (this.contractInfoBody.contractTransportationCost > 0) {
            this.model.hasTransportationCost = true;
            this.model.transportationCost = this.contractInfoBody.contractTransportationCost;
          } else {
            if (this.isAssistanceWithoutInterpreter) {
              this.model.hasTransportationCost = false;
            }
            this.model.transportationCost = 0;
          }
        }
      },
      immediate: true,
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.bg-gray-light {
  background-color: map-get($colors, 'secondary-13');
}

.border-gold {
  border-color: solid 1px #fdac41;
}

.btn-action-size {
  width: 35px;
  height: 35px;
}
</style>
